/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Model for updating organization via superadmin.
 * @export
 * @interface OrganizationUpdate
 */
export interface OrganizationUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdate
     */
    license_key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUpdate
     */
    owner_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUpdate
     */
    is_active?: boolean | null;
}

/**
 * Check if a given object implements the OrganizationUpdate interface.
 */
export function instanceOfOrganizationUpdate(value: object): value is OrganizationUpdate {
    return true;
}

export function OrganizationUpdateFromJSON(json: any): OrganizationUpdate {
    return OrganizationUpdateFromJSONTyped(json, false);
}

export function OrganizationUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'license_key': json['license_key'] == null ? undefined : json['license_key'],
        'owner_id': json['owner_id'] == null ? undefined : json['owner_id'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
    };
}

export function OrganizationUpdateToJSON(json: any): OrganizationUpdate {
    return OrganizationUpdateToJSONTyped(json, false);
}

export function OrganizationUpdateToJSONTyped(value?: OrganizationUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'license_key': value['license_key'],
        'owner_id': value['owner_id'],
        'is_active': value['is_active'],
    };
}

